import axios from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    authSettings: {
      show_login_form: false,
      show_registration_form: false,
      custom_texts: {},
    },
  },
  getters: {
    getAuthSettings: state => state.authSettings,
  },
  mutations: {
    SET_AUTH_SETTINGS(state, val) {
      state.authSettings = val
    },
  },
  actions: {
    async fetchAuthSettings({ commit }) {
      try {
        const response = await axios.get('auth-settings')
        commit('SET_AUTH_SETTINGS', response.data.data)
        return response
      } catch (error) {
        return error
      }
    },
    async fetchAuthUserBriefData(ctx, queryParams) {
      try {
        const response = await axios.get('user-auth/me-brief', { params: queryParams })
        return response.data.data
      } catch (error) {
        return error
      }
    },
    async fetchPermissions() {
      const { data } = await axios.get('user-auth/permissions')
      return data.data
    }
  },
}